import { render, staticRenderFns } from "./DeleteReportCustomComponent.vue?vue&type=template&id=2b616e1c"
import script from "./DeleteReportCustomComponent.vue?vue&type=script&lang=js"
export * from "./DeleteReportCustomComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports